export default function initHeadlineReveal() {
    const section = document.querySelector('.headline-section');
    const text = document.querySelector('.reveal-text');

    if (!section || !text) return;

    const handleScroll = () => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const windowHeight = window.innerHeight;
        const scrollPos = window.scrollY;

        // Calcola il progresso basato sullo scroll nella sezione
        let progress = (scrollPos - sectionTop) / (sectionHeight - windowHeight);
        progress = Math.max(0, Math.min(1, progress));

        // Applica l'effetto tramite variabile CSS o backgroundSize
        text.style.backgroundSize = `${progress * 100}% 100%`;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Esegui una volta al caricamento per settare lo stato iniziale
    handleScroll();
}